import useData from "./useData";
import config from "../../config/apiService.json";

const useNotices = () => {
    const {home} = config;
    const {notices: noticesApiEndPoint} = home;
    const {data, isLoading} = useData(`${noticesApiEndPoint}?currentPage=0&recordPerPage=5`);
    return {data, isLoading};
}
export default useNotices;
